import slugify from './slugify';
import deconstructLocation from './deconstructLocation';

const locationUrl = ({ breadcrumbs, state, suburb, suburbUrl }) => {
  let url = [];
  if (breadcrumbs && !!breadcrumbs.length) {
    url = breadcrumbs.reduce(
      (aggregate, { url_slug: urlSlug, breadcrumb }, index) => {
        if (
          aggregate.length &&
          aggregate[aggregate.length - 1] === `/${urlSlug}`
        )
          return aggregate;
        return aggregate.concat(`/${slugify(breadcrumb)}`);
      },
      []
    );

    return url.join('');
  }
  if (state || suburb) {
    let suburbParts = {};
    if (suburbUrl) {
      suburbParts = deconstructLocation(suburbUrl);
    }
    if (state) {
      url.push(`/${slugify(state)}`);
    }
    if (suburb) {
      if (suburbParts && suburbParts.postcode) {
        url.push(slugify(`${suburb} ${suburbParts.postcode}`));
      } else {
        url.push(slugify(suburb));
      }
    }

    return url.join('/');
  }

  return null;
};

export default locationUrl;
